import { render, staticRenderFns } from "./SecondaryTabs.vue?vue&type=template&id=006b0c09&"
import script from "./SecondaryTabs.vue?vue&type=script&lang=js&"
export * from "./SecondaryTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports